

export default function OnPending(){

    return (
        <div>
            <h3 className="light-text">Your signup request has been received. Once approved you will become a player for ANU Pennant.</h3>
        </div>
    )
}